<template>
  <div class="mod-aside-nav-view">
    <div class="mod-aside-nav-mask" v-show="navStatus === 'open'"></div>
    <div class="mod-aside-nav" :class="navStatus === 'close' ? '' : 'open'">
      <div class="mod-aside-nav-btn" @click="showNav"  :class="navStatus === 'close' ? 'left' : 'right'">{{ navTitle[navStatus] }}</div>
      <div class="side-nav-items">
        <div class="item" v-for="(i, k) in navItems" :key="k" @click="goPage(i)">
          <img :src="require(`../../assets/aside-icon-0${ k + 1 }.png`)" alt="">
          <span>{{ i.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AsideNav",
  data () {
    return {
      navTitle: {
        open: '收起',
        close: '导航'
      },
      navStatus: 'close',
      navItems: [
        {
          name: '首页',
          src: '/',
          isShop: true
        },
        {
          name: '我的',
          src: '/mine',
          isShop: true
        },
        {
          name: '购物车',
          src: '/shoppingCart',
          isShop: true
        },
        {
          name: '订单',
          src: '/orderAll',
          isShop: true
        }
        /* ,{
          name: '公众号',
          src: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA3NTUwOTg1OA==&scene=124#wechat_redirect',
          isShop: false
        } */
      ]
    }
  },
  methods: {
    showNav () {
      this.navStatus = this.navStatus === 'close' ? 'open' : 'close'
    },
    goPage (record) {
      this.navStatus = 'close'
      if (record.isShop) {
        this.$router.push(record.src)
      } else {
        const a = document.createElement("a")
        a.setAttribute("href", record.src);
        a.click();
        // window.location.href = record.src
      }
    }
  }
}
</script>

<style scoped>
  .mod-aside-nav-view {
    font-size: 12px;
  }

  .mod-aside-nav-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.3);
  }

  .mod-aside-nav {
    position: fixed;
    bottom: 15vh;
    right: -195px;
    width: 195px;
    height: 2.0rem;
    display: flex;
    transition: all .3s;
  }

  .mod-aside-nav.open {
    right: 0;
  }

  .mod-aside-nav-btn {
    width: 30px;
    height: 26px;
    background: rgba(0,0,0,.7);
    position: absolute;
    left: -45px;
    top: 50%;
    margin-top: -25px;
    border-radius: .08rem 0 0 .08rem;
    color: #fff;
    line-height: 12px;
    background-position: left center;
    background-size: .30rem .30rem;
    background-repeat: no-repeat;
    padding: 12px 0px 12px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mod-aside-nav-btn.left {
    background-image: url('../../assets/aside-icon-l.png');
  }

  .mod-aside-nav-btn.right {
    background-image: url('../../assets/aside-icon-r.png');
  }

  .side-nav-items {
    background: #fff;
    width: 195px;
    padding: .20rem 0 .08rem;
    border-radius: .08rem 0 0 .08rem;
  }

  .side-nav-items .item {
    display: inline-block;
    width: 33.33%;
    text-align: center;
    padding: .10rem 0;
  }

  .side-nav-items img {
    width: 20px;
    margin: 0 auto .05rem;
  }

  .side-nav-items span {
    line-height: .15rem;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/AsideNav.vue